module.exports = __webpack_public_path__ + "img/grid.ecc02b54.svg";